module.exports = __webpack_public_path__ + "static/media/thank-you-thumb.7f546d66.jpg";